import { motion } from 'framer-motion';
import React from 'react';
import useVisibility from '../../Hooks/useVisibility';
import { ReactComponent as CloseIcon } from '../../Icons/close.svg';
import PopUp from '../../SharedComponents/PopUp';
import '../../Styles/Animations/ContactList.css';
import '../../Styles/Contact/ChatModal.css';
import ChatModal from '../Contact/ChatModal';

const ContactList = () => {

    const [showChatModal, toggleShowChatModal] = useVisibility();
    const [showMailId, toggleShowMailId] = useVisibility();

    return (
        <div className="contact-list-main-container flex-box">
            <ul className="list-items-container flex-box">
                <motion.li className="list-item" initial={{ x: `-1500%` }} animate={{ x: 0 }} transition={{ ease: `easeInOut`, duration: 0.8, delay: 0.3 }}>
                    <div onClick={() => window.open(`https://github.com/Guru-Eco`)}>
                        <i className="fa fa-github" aria-hidden="true"></i>
                        <span> - GitHub</span>
                    </div>
                </motion.li>
                <motion.li className="list-item" initial={{ x: `-1200%` }} animate={{ x: 0 }} transition={{ ease: `easeInOut`, duration: 0.8, delay: 0.2 }}>
                    <div onClick={() => window.open(`https://www.linkedin.com/in/gurunath-a-s/`)}>
                        <i className="fa fa-linkedin-square" aria-hidden="true"></i>
                        <span> - LinkedIn</span>
                    </div>
                </motion.li>
                <motion.li className="list-item" initial={{ x: `-900%` }} animate={{ x: 0 }} transition={{ ease: `easeInOut`, duration: 0.8, delay: 0.1 }}>
                    <div to="/contact" onClick={toggleShowMailId}>
                        <i className="fa fa-envelope" aria-hidden="true"></i>
                        <span> - G-mail</span>
                    </div>
                </motion.li>
                <motion.li className="list-item" initial={{ x: `-600%` }} animate={{ x: 0 }} transition={{ ease: `easeInOut`, duration: 0.8 }}>
                    <div to="/contact" onClick={toggleShowChatModal}>
                        <i className="fa fa-comments" aria-hidden="true"></i>
                        <span> - Message</span>
                    </div>
                </motion.li>
            </ul>
            {
                showChatModal && (
                    <div className="chat-modal-popup-wrapper flex-box">
                        <PopUp className="chat-modal-main-container-wrapper flex-box">
                            <ChatModal toggleShowChatModal={toggleShowChatModal} />
                        </PopUp>
                    </div>
                )
            }
            {
                showMailId && (
                    <div className="chat-modal-popup-wrapper flex-box">
                        <PopUp className="chat-modal-main-container-wrapper flex-box">
                            <div className="chat-model-close-icon flex-box mail-cancel-button" onClick={toggleShowMailId}>
                                <CloseIcon />
                            </div>
                            <div className="mail-heading-wrapper flex-box">
                                <h1>Mail me at</h1>
                            </div>
                            <p className="mail-id-box flex-box">abhimanyu768692@gmail.com</p>
                        </PopUp>
                    </div>
                )
            }
        </div>
    )
}

export default ContactList
